import Newsletter, { SUBSCRIPTION_EMAIL_EXISTS, SUBSCRIPTION_NO_CONSENT } from '../classes/Newsletter';

const initNewsletterForms = () => {
    const newsletter = new Newsletter();
    const newsletterForms = document.querySelectorAll('form.js-newsletter-subscription-form');

    for (let i = 0; i < newsletterForms.length; i++) {
        const newsletterForm = newsletterForms[i];
        newsletter.setupForm(newsletterForm);
        const newsletterFormMessage = newsletterForm.querySelector('.js-footer-newsletter-message');
        newsletterForm.addEventListener('subscription:error', (e) => {
            newsletterFormMessage.querySelector('span').classList.remove('u-success')
            newsletterFormMessage.querySelector('span').classList.add('u-error')
            if (newsletterFormMessage) {
                newsletterFormMessage.style.display = 'flex';

                if (e.detail.error.code === SUBSCRIPTION_EMAIL_EXISTS) {
                    newsletterFormMessage.querySelector('span').innerHTML = Shopify.translations.newsletter.newsletter_email_exists;
                    return;
                }

                if (e.detail.error.code === SUBSCRIPTION_NO_CONSENT) {
                    newsletterFormMessage.querySelector('span').innerHTML = Shopify.translations.newsletter.newsletter_no_consent;
                    return;
                }

                newsletterFormMessage.querySelector('span').innerHTML = Shopify.translations.newsletter.newsletter_error;
            }
        });

        newsletterForm.addEventListener('subscription:success', (e) => {
            newsletterFormMessage.querySelector('span').classList.remove('u-error')
            newsletterFormMessage.querySelector('span').classList.add('u-success')
            newsletterFormMessage.style.display = 'flex';
            newsletterFormMessage.querySelector('span').innerHTML = Shopify.translations.newsletter.newsletter_success;
        });
    }
}

const initCheckboxApparition = () => {
    const newsletterFormInput = document.querySelector('.js-footer-newsletter-form-input')
    const newsletterCheckboxWrapper = document.querySelector('.js-footer-newsletter-form-checkbox')

    if (!newsletterFormInput) {
        newsletterCheckboxWrapper.classList.remove('u-none')
    } else {
        newsletterFormInput.addEventListener('focus', () => {
            newsletterCheckboxWrapper.classList.remove('u-none')
        })
    }
}

window.onload = () => {
    initCheckboxApparition();
    initNewsletterForms();
};
